import { useSelector } from 'react-redux';

export const useProfitForecastInformationBlock = () => {
    //@ts-ignore
    const { financial_info } = useSelector((store) => store.dashboardReducer);
    return { financial_info };
};
